<template>
    <div class="box" ref="DOM">
        <div class="top" id="top">
            <div class="header">
                <img src="../../static/img/logo.png" alt="广东省流动人员人事档案公共服务平台">
                <h1><span @click="toRsdabzh()" style="cursor:pointer">广东省流动人员人事档案公共服务平台</span><span> - 省人才服务局</span>
                </h1>
                <div>
                    <a style="margin-right: 10px;color: #fff;text-decoration: none" title="无障碍浏览模式" href="javascript:;"
                       onclick="ShowDetail()" accesskey="g" onmousedown="ShowDetail()" target="_self">无障碍浏览模式</a>


                    <template v-if="resultData.username">
                        <span class="el-icon-user" style="font-size: 1rem"></span><span style="cursor: pointer"> &nbsp;{{resultData.username}}</span>
                        <span style="font-size: 1rem;margin-left: .5rem;" @click="toLogout"> <span
                                class="el-icon-switch-button"
                                style="font-size: 1rem"></span><span
                                style="font-size: 1rem;cursor: pointer">&nbsp;退出登录</span></span>
                    </template>
                    <template v-else>
                        <el-button @click="toLogin()">登录</el-button>
                        <el-button @click="toRegist()">注册</el-button>

                    </template>
                </div>
            </div>
            <nav>
                <ul>
                    <li :class="navType==0?'active':''" @click="toScroll(0)">首页</li>
                    <li :class="navType==5?'active':''" @click="pageType=3,navType=5">办事指南</li>
                    <li @click="toLogin('doneBusiness')">我的已办</li>
                    <p></p>
                    <el-select
                            class="select"
                            style="height: 2.25rem;border-radius: 2.25rem 0 0 2.25rem;width: 14rem;position: absolute;top: 0.5rem;right: 6rem"
                            v-model="value"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                            :loading="loading">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>

                    </el-select>
                    <el-button type="primary"
                               @click="toSearh"
                               style="position: absolute;top: 0.5rem;right: 0;height: 2.25rem;padding:0;line-height: 2.25rem;background-color: #264B8F;width: 6rem;text-align: center;border: none"
                               icon="el-icon-search">搜索
                    </el-button>
                </ul>
            </nav>
            <div v-if="pageType==1">
                <div  class="content">
                    <div class="div1">
                        <div>
                            <p>
                                <img src="../../static/img1/人@1.5x.png" alt="个人服务">
                                <span>个人服务</span>
                            </p>
                            <ul>
                                <li @click="toLogin('archivesInto')">
                                    <img src="../../static/img1/icon1@1.5x.png" alt="档案接收">
                                    <span>档案接收</span>
                                </li>
                                <li @click="toLogin('archivesTurnOut')">
                                    <img src="../../static/img1/icon2@1.5x.png" alt="档案转出">
                                    <span>档案转出</span>
                                </li>
                                <li @click="toLogin('recordSearch')">
                                    <img src="../../static/img1/icon3@1.5x.png" alt="档案存储地查询">
                                    <span>档案存储地查询</span>
                                </li>
                                <li @click="toLogin('certify')">
                                    <img src="../../static/img1/icon4@1.5x.png" alt="出具证明">
                                    <span>出具证明</span>
                                </li>

                                <li @click="toLogin('archivesGather')">
                                    <img src="../../static/img1/icon5@1.5x.png" alt="档案材料归档">
                                    <span>档案材料归档</span>
                                </li>
                                <!--<li @click="toPage1">-->
                                <!--<img src="../../static/img1/icon5@1.5x.png" alt="">-->
                                <!--<span>毕业生报到</span>-->
                                <!--</li>-->
                                <li @click="toLogin('censusBusiness')">
                                    <img src="../../static/img1/icon7@1.5x.png" alt="集体户业务">
                                    <span>集体户业务</span>
                                </li>
                                <li @click="toLogin('relationTransfer')">
                                    <img src="../../static/img1/a1.png" alt="党员相关业务">
                                    <span>党员相关业务</span>
                                </li>
                                <li @click="toLogin('acceptance')">
                                    <img src="../../static/img1/b1.png" alt="毕业生接收">
                                    <span>毕业生接收</span>
                                </li>
                                <li @click="toLogin('zsCertify')">
                                    <img src="../../static/img1/icon4@1.5x.png" alt="政审（考察）服务">
                                    <span>政审（考察）服务</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="div2">
                        <div>
                            <p>
                                <img src="../../static/img1/单位@1.5x.png" alt="单位服务">
                                <span>单位服务</span>
                            </p>
                            <ul>
                                <li @click="toLogin('archivesInto')">
                                    <img src="../../static/img1/icon8@1.5x.png" alt="档案接收">
                                    <span>档案接收</span>
                                </li>
                                <li @click="toLogin('archivesTurnOut')">
                                    <img src="../../static/img1/icon9@1.5x.png" alt="档案转出">
                                    <span>档案转出</span>
                                </li>

                                <li @click="toLogin('recordSearch')">
                                    <img src="../../static/img1/icon10@1.5x.png" alt="档案存储地查询">
                                    <span>档案存储地查询</span>
                                </li>
                                <li @click="toLogin('certify')">
                                    <img src="../../static/img1/icon11@1.5x.png" alt="出具证明">
                                    <span>出具证明</span>
                                </li>
                                <li @click="toLogin('archivesGather')">
                                    <img src="../../static/img1/icon12@1.5x.png" alt="档案材料归档">
                                    <span>档案材料归档</span>
                                </li>
                                <li @click="toLogin('archivesBorrowing')">
                                    <img src="../../static/img1/icon13@1.5x.png" alt="档案查阅">
                                    <span>档案查阅</span>
                                </li>

                                <li @click="toLogin('archivesBorrow')">
                                    <img src="../../static/img1/icon14@1.5x.png" alt="档案借阅">
                                    <span>档案借阅</span>
                                </li>
                                <li @click="toLogin('zsCertify')">
                                    <img src="../../static/img1/icon11@1.5x.png" alt="政审（考察）服务">
                                    <span>政审（考察）服务</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="div3">
                        <div>
                            <img style="width: 10.9375rem;height: 1.9375rem;margin: -0.875rem auto 0;display: block;"
                                 src="../../static/img/topbg@1.5x.png" alt="温馨提示"/>
                            <p>
                                <strong style="width:85%;text-align: center;display: inline-block;text-indent: 0;">关于润粤大厦三楼办事大厅停止办理业务的公告
                                </strong>
                                <br>
                                <span style="display: inline-block;text-indent: 0em;">尊敬的办事人员：</span>
                                <span style="display: inline-block;text-indent: 2em;">
                                    按照我局办事大厅搬迁的通知，润粤大厦三楼办事大厅于2022年11月18日起停止办理业务，请您前往粤港澳大湾区（广东）人才港公共服务大厅（地址：广州市越秀区东风中路389号壬丰商务大厦5楼），或登录广东省流动人员人事档案公共服务平台（网址：https://ggfw.hrss.gd.gov.cn/rsda）办理业务。
                                </span>
                                <!--<span style="display: block;text-indent: 2em;">
                                  咨询电话：020-12333选“省级”，按“9”键。
                                </span>-->
                                <span style="display: inline-block;text-indent: 2em;">
                                    咨询电话：（020）12345
                                </span>
                                <br>
                                <span style="display: inline-block;text-indent: 2em;">
                                    特此公告！
                                </span>
                                <br>
                                <span style="float: right;color: #000">广东省人才服务局</span>
                                <br>
                                <span style="float: right;color: #000">2022年11月18日</span>
                            </p>
                            <span class="before">温馨提示</span>

                        </div>
                        <p class="bottom" @click="toLogin('messageBoard')">
                            <img src="../../static/img1/q@1.5x.png" alt="意见反馈">
                            <span>意见反馈</span>
                        </p>
                    </div>
                </div>

            </div>
            <div v-if="pageType==3"
                 style="width: 100%;height:calc(100vh - 9.375rem);background-color: #fff; padding: 1em;box-sizing: border-box;overflow-y: scroll">
                <br>
                <br>
                <div style="width: 75rem;margin: 0 auto;color: #000">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div>
                                <el-menu
                                        default-active="1-1"
                                        class="el-menu-vertical-demo"
                                        @open="handleOpen"
                                        @close="handleClose">
                                    <el-submenu index="1">
                                        <template slot="title">
                                            <span class="el-icon-menu"></span>
                                            <span class="f16">档案类业务</span>
                                        </template>
                                        <el-menu-item-group>

                                            <el-menu-item index="1-1" @click="setZNVal('1-1')">高等学校等毕业生接收手续办理
                                            </el-menu-item>
                                            <el-menu-item index="1-2" @click="setZNVal('1-2')">档案接收</el-menu-item>
                                            <el-menu-item index="1-3" @click="setZNVal('1-3')">档案转出</el-menu-item>
                                            <el-menu-item index="1-4" @click="setZNVal('1-4')">档案材料的收集、鉴别和归档
                                            </el-menu-item>
                                            <el-menu-item index="1-5" @click="setZNVal('1-5')">档案查阅</el-menu-item>
                                            <el-menu-item index="1-6" @click="setZNVal('1-6')">档案借阅</el-menu-item>
                                            <el-menu-item index="1-7" @click="setZNVal('1-7')">依据档案记载出具相关证明
                                            </el-menu-item>
                                            <el-menu-item index="1-8" @click="setZNVal('1-8')">为相关单位提供政审（考察）服务
                                            </el-menu-item>
                                        </el-menu-item-group>
                                    </el-submenu>

                                    <el-submenu index="2">
                                        <template slot="title">
                                            <span class="el-icon-menu"></span>
                                            <span class="f16">集体户业务</span>
                                        </template>
                                        <el-menu-item-group>
                                            <el-menu-item index="2-1" @click="setZNVal('2-1')">户口页借出</el-menu-item>
                                            <el-menu-item index="2-7" @click="setZNVal('2-7')">户口页续借</el-menu-item>
                                            <el-menu-item index="2-2" @click="setZNVal('2-2')">户口页归还</el-menu-item>
                                            <el-menu-item index="2-3" @click="setZNVal('2-3')">户口迁出</el-menu-item>
                                            <el-menu-item index="2-4" @click="setZNVal('2-4')">结婚备案</el-menu-item>
                                            <el-menu-item index="2-5" @click="setZNVal('2-5')">离婚备案</el-menu-item>
                                            <el-menu-item index="2-6" @click="setZNVal('2-6')">生育备案</el-menu-item>
                                        </el-menu-item-group>
                                    </el-submenu>
                                    <el-submenu index="3">
                                        <template slot="title">
                                            <span class="el-icon-menu"></span>
                                            <span class="f16">党员相关业务</span>
                                        </template>
                                        <el-menu-item-group>
                                          <!--  <el-menu-item index="3-1" @click="setZNVal('3-1')">存档人员党员组织关系转入
                                            </el-menu-item>-->
                                            <el-menu-item index="3-2" @click="setZNVal('3-2')">存档人员党员组织关系转出
                                            </el-menu-item>
                                            <el-menu-item index="3-3" @click="setZNVal('3-3')">存档人员党员组织关系证明
                                            </el-menu-item>
                                            <el-menu-item index="3-4" @click="setZNVal('3-4')">存档人员党费交纳</el-menu-item>
                                        </el-menu-item-group>
                                    </el-submenu>

                                </el-menu>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="table">
                                <div v-show="ywsm=='3-1'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                存档人员党员组织关系转入
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>存档人员党员组织关系转入</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>
                                                档案在广东省人才服务局保管，居住地、工作单位及其所在地党组织均无法接收组织关系的党员，可申请将组织关系转入广东省人才服务局流动人才党委。
                                            </td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>
                                                1.党员本人身份证原件；<br>
                                                2.工作单位无党组织或无工作单位证明；<br>
                                                3.连续居住不满6个月的证明。
                                            </td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">现场办理<br></font><font class="font5">提交办理材料
                                                → 工作人员现场审核 → 审核通过，工作人员办理转入，业务办结。</font></td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">申请人注册登录广东省流动人员人事档案公共服务平台
                                                (https://ggfw.hrss.gd.gov.cn/rsda) → 党员相关业务 → 组织关系转入 → 上传办理材料扫描件 →
                                                工作人员系统审核 → 审核通过，由工作人员操作转入，业务办结。</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>当场送达</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收费依据及标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        &lt;!&ndash; <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>&ndash;&gt;
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公。
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        &lt;!&ndash; <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                           <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>&ndash;&gt;
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='3-2'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                存档人员党员组织关系转出
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>存档人员党员组织关系转出</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>
                                                党员组织关系在广东省人才服务局流动人才党委的党员，符合下列条件之一的，应当及时办理组织关系转出：<br>
                                                1.已纳入社区管理的离退休党员；<br>
                                                2.档案已转出本机构的党员；<br>
                                                3.工作单位已成立党组织的党员；<br>
                                                4.已有稳定居住地（连续6个月以上）的党员。<br>
                                                注：办理党组织关系转出，党费须交至转出当月。
                                            </td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>党员本人身份证原件（如委托他人办理，需出具本人手写委托书及双方身份证原件）</td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">现场办理<br></font><font class="font5">提交办理材料，提供接收党组织的全称
                                                → 由工作人员操作转出，业务办结。</font></td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">申请人注册登录广东省流动人员人事档案公共服务平台
                                                (https://ggfw.hrss.gd.gov.cn/rsda) → 党员相关业务 → 组织关系转出 → 填写接收党组织的全称 →
                                                选择“是否需要复印入党志愿书、是否需要开具纸制版介绍信”，填写收件信息，提交审核 → 工作人员系统审核 →
                                                审核通过，由工作人员操作转出，业务办结。<br><br>

                                                注：本人需在30天内到接收党组织报到</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>当场送达</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收费依据及标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公。
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!--  <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                            <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                            <td class='x24'>人社系统投诉电话：12333</td>
                                          </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='3-3'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                存档人员党员组织关系证明
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>存档人员党员组织关系证明</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>
                                                党员组织关系在广东省人才服务局流动人才党委的党员，可申请开具党员组织关系证明，该证明仅用于证明党员身份和党费交纳情况。<br>
                                                注：开具党员组织关系证明，党费需交至当月。
                                            </td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>党员本人身份证原件（如委托他人办理，需出具本人手写委托书及双方身份证原件）</td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">现场办理<br></font><font class="font5">提交办理材料
                                                → 工作人员核查党员档案材料及党费交纳情况 → 开具证明，业务办结。</font></td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">申请人注册登录广东省流动人员人事档案公共服务平台
                                                (https://ggfw.hrss.gd.gov.cn/rsda) → 党员相关业务 → 组织关系证明 → 填写用途，提交审核 →
                                                工作人员系统审核 → 审核通过 → 申请人在线下载证明，业务办结。</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>现场办理的，当场送达；<br>
                                                网上办理的，在线下载。
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收费依据及标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公。
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!--<tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                          <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                          <td class='x24'>人社系统投诉电话：12333</td>
                                        </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='3-4'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                存档人员党费交纳
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>存档人员党费交纳</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>党组织关系在广东省人才服务局流动人才党委的党员，应当主动按月交纳党费。</td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>无</td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">现场办理<br></font><font class="font5">提交办理材料
                                                → 党费交至当月 → 业务办结。</font></td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">申请人注册登录广东省流动人员人事档案公共服务平台
                                                (https://ggfw.hrss.gd.gov.cn/rsda) → 党员相关业务 → 党费缴纳 →
                                                自动生成党费账单，微信扫码支付，业务办结。</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>当场送达</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收费依据及标准</td>
                                            <td class='x27'>中组部《关于中国共产党党费收缴、使用和管理的规定》（中组发〔2008〕3号）</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30<br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公。
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                           <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>


                                <div v-show="ywsm=='2-1'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                户口页借出
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>户口页借出</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员借用户口页</td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>1、本人办理：有效身份证件<br>2、委托代办：申请人员亲笔签名的委托书（注明双方联系方式）、委托人有效身份证件复印件以及受委托人有效身份证件原件。
                                            </td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">窗口办理<br></font><font class="font5">取号→提交申请材料→说明借用户口页原因→审核通过→工作人员将集体户首页复印件、个人页原件以及业务受理回执当场给申请人。

                                                <br>材料审核不通过→当场告知不通过原因。<br>注：户口个人页使用完毕请及时归还。</font></td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→申请户口页借出→选择借出原因→填写邮寄信息→提交审核→系统审核→审核通过→工作人员通过EMS寄出集体户首页复印件、个人页原件以及业务受理回执→申请人签收户口页及业务受理回执。
                                                <br>材料审核不通过→注明不通过原因。<br>注：户口个人页使用完毕请及时归还。</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，邮寄送达。</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公。
                                            </td>
                                        </tr>
                                        <!-- <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                           <td height='96' class='x23' style='height:72.5pt;'>咨询查询途径</td>
                                           <td class='x24'>现场咨询：广东省人才服务局服务大厅咨询窗口<br>电话咨询：020-12333-9<br>网站查询：登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）可查看办事指南、查询档案在库信息、在线申办业务</td>
                                         </tr>-->
                                        <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                            <td height='55' class='x23' style='height:41.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>
                                <div v-show="ywsm=='2-7'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='658' style='mso-width-source:userset;width:493.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='798' style='height:23.25pt;'>
                                                户口页续借
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>户口页续借</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>在借出户口首页复印件有效期内，在户人员因办理其他事项另需借用户口首页复印件</td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x24'>本人有效身份证件<br>（委托他人代办的，需提供本人手写签名的委托书原件、双方有效身份证件复印件）</td>
                                        </tr>
                                        <tr height='164' style='mso-height-source:userset;height:123pt' name='r4'>
                                            <td rowspan='2' height='329' class='x29'
                                                style='border-right:1px solid windowtext;height:247.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">窗口办理<br></font><font class="font5">取号→本人出示有效身份证件原件（委托他人代办的，提供本人手写签名的委托书原件、双方有效身份证件复印件），告知工作人员借出户口页原因→工作人员现场审核→审核通过，工作人员出具集体户首页复印件以及业务受理回执，业务办结。<br>审核不通过→当场告知不通过原因。<br>注：户口个人页使用完毕请及时归还，如借出户口页办理婚育相关事项，请在归还前登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）上传备案材料。</font>
                                            </td>
                                        </tr>
                                        <tr height='166' style='mso-height-source:userset;height:125pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">申请人注册登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）→网上申请户口页续借→选择借出原因，填写邮寄信息，并提交审核→工作人员系统审核→审核通过，工作人员通过EMS寄出集体户首页复印件以及业务受理回执→申请人签收户口页及业务受理回执，业务办结。<br>审核不通过→注明不通过原因。<br>注：户口个人页使用完毕请及时归还，如借出户口页办理婚育相关事项，请在归还前登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）上传备案材料。</font>
                                            </td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，邮寄送达。</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r8'>
                                            <td height='96' class='x23' style='height:72.5pt;'>收费标准</td>
                                            <td class='x27'>收费标准：免费<br></td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                         <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                         <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                       </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!-- <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                           <td height='96' class='x23' style='height:72.5pt;'>咨询查询途径</td>
                                           <td class='x24'>现场咨询：广东省人才服务局服务大厅咨询窗口<br>电话咨询：020-12333-9<br>网站查询：登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）可查看办事指南、查询档案在库信息、在线申办业务</td>
                                         </tr>-->
                                        <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                            <td height='55' class='x23' style='height:41.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='658' style='width:493.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='2-2'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='796' style='border-collapse:
 collapse;table-layout:fixed;width:597pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='656' style='mso-width-source:userset;width:492pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='796' style='height:23.25pt;'>
                                                户口页归还
                                            </td>
                                        </tr>
                                        <tr height='38' style='mso-height-source:userset;height:29pt' name='r1'>
                                            <td height='36' class='x23' style='height:27.5pt;'>事项名称</td>
                                            <td class='x24'>户口页归还</td>
                                        </tr>
                                        <tr height='38' style='mso-height-source:userset;height:29pt' name='r2'>
                                            <td height='36' class='x23' style='height:27.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员归还户口个人页</td>
                                        </tr>
                                        <tr height='38' style='mso-height-source:userset;height:29pt' name='r3'>
                                            <td height='36' class='x25' style='height:27.5pt;'>办理材料</td>
                                            <td class='x24'>户口个人页原件</td>
                                        </tr>
                                        <tr height='133' style='mso-height-source:userset;height:100pt' name='r4'>
                                            <td rowspan='2' height='289' class='x29'
                                                style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:217.25pt;'>
                                                办理方式
                                            </td>
                                            <td class='x26'><font class="font4">窗口办理</font><font
                                                    class="font6"><br></font><font class="font5">取号→提交申请材料→审核通过→工作人员签收户口个人页→业务办结。</font><font
                                                    class="font7"><br></font><font class="font5"></font><font
                                                    class="font7"><br></font><font class="font5">注：如借出户口页办理婚育事项，请在归还前登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）进行婚育备案登记。</font>
                                            </td>
                                        </tr>
                                        <tr height='157' style='mso-height-source:userset;height:118pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→申请户口页归还→填写邮寄信息并寄出户口个人页→工作人员签收户口个人页→业务办结。<br><br>注：如借出户口页办理婚育事项，请在归还前登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）进行婚育备案登记。</font>
                                            </td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r7'>
                                            <td height='44' class='x23' style='height:33.5pt;'>结果送达</td>
                                            <td class='x24'>无</td>
                                        </tr>
                                        <tr height='92' style='mso-height-source:userset;height:69pt' name='r8'>
                                            <td height='90' class='x23' style='height:67.5pt;'>收费标准</td>
                                            <td class='x27'>免费<br></td>
                                        </tr>
                                        <!-- <tr height='68' style='mso-height-source:userset;height:51pt' name='r9'>
                                           <td height='66' class='x23' style='height:49.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r10'>
                                            <td height='54' class='x23' style='height:40.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='60' style='mso-height-source:userset;height:45pt' name='r12'>
                                           <td height='58' class='x23' style='height:43.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='656' style='width:492pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='2-3'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='766' style='border-collapse:
 collapse;table-layout:fixed;width:574pt'>
                                        <col class='x22' width='122' style='mso-width-source:userset;width:91.5pt'>
                                        <col class='x21' width='644' style='mso-width-source:userset;width:483pt'>
                                        <tr height='36' style='mso-height-source:userset;height:27pt' name='r0'>
                                            <td colspan='2' height='35' class='x28' width='766' style='height:26.25pt;'>
                                                户口迁出
                                            </td>
                                        </tr>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r1'>
                                            <td height='30' class='x23' style='height:22.5pt;'>事项名称</td>
                                            <td class='x24'>户口迁出</td>
                                        </tr>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r2'>
                                            <td height='30' class='x23' style='height:22.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员申请将户口迁出集体户</td>
                                        </tr>
                                        <tr height='94' style='mso-height-source:userset;height:71pt' name='r3'>
                                            <td height='92' class='x25' style='height:69.5pt;'>办理材料</td>
                                            <td class='x24'>1、本人办理：有效身份证件<br>2、委托代办：申请人员手写签名的委托书（注明双方联系方式）、委托人有效身份证件复印件以及受委托人有效身份证件原件。
                                            </td>
                                        </tr>
                                        <tr height='148' style='mso-height-source:userset;height:111pt' name='r4'>
                                            <td rowspan='2' height='300' class='x29'
                                                style='border-right:1px solid windowtext;height:225.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4">窗口办理<br></font><font class="font5">取号→提交申请材料→填写户口迁出申请表→审核通过→工作人员开具集体户首页复印件、个人页原件以及业务受理回执，当场交申请人。（注：迁户人员需自行到公安部门办理户口迁移手续，迁户未批准的请及时将户口页归还我局）<br>审核不通过→当场告知不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='153' style='mso-height-source:userset;height:115pt' name='r5'>
                                            <td class='x26 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→申请户口迁出→选择迁户类型→填写户口迁往地址→提交审核→系统审核→审核通过→工作人员通过EMS寄出集体户首页复印件、个人页原件以及业务受理回执→本人签收户口页及业务受理回执。（注：迁户人员需自行到公安部门办理户口迁移手续，迁户未批准的请及时将户口页归还我局）<br>审核不通过→注明不通过原因。<br>注：已迁出户口的，户口个人页无需归还。</font>
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r6'>
                                            <td height='38' class='x23' style='height:28.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='53' style='mso-height-source:userset;height:40pt' name='r7'>
                                            <td height='51' class='x23' style='height:38.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，邮寄送达。</td>
                                        </tr>
                                        <tr height='93' style='mso-height-source:userset;height:70pt' name='r8'>
                                            <td height='91' class='x23' style='height:68.5pt;'>收费标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r10'>
                                            <td height='54' class='x23' style='height:40.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='80' style='mso-height-source:userset;height:60pt' name='r11'>
                                            <td height='78' class='x23' style='height:58.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='58' style='mso-height-source:userset;height:44pt' name='r12'>
                                           <td height='56' class='x23' style='height:42.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='122' style='width:91.5pt'></td>
                                            <td width='644' style='width:483pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='2-4'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='843' style='border-collapse:
 collapse;table-layout:fixed;width:632pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='703' style='mso-width-source:userset;width:527.25pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='843' style='height:23.25pt;'>
                                                结婚备案
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>结婚备案</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员在办理结婚登记后进行备案</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r3'>
                                            <td height='54' class='x25' style='height:40.5pt;'>办理材料</td>
                                            <td class='x24'>双方身份证、双方结婚证、配偶户口本</td>
                                        </tr>
                                        <tr height='102' style='mso-height-source:userset;height:77pt' name='r4'>
                                            <td rowspan='2' height='225' class='x29'
                                                style='border-right:1px solid windowtext;height:169.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4"><br>窗口办理<br></font><font class="font5">取号→提交申请材料→审核通过→工作人员登记信息→业务办结。<br>审核不通过→当场告知不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='124' style='mso-height-source:userset;height:93pt' name='r5'>
                                            <td class='x26 first'><font class="font4"><br>网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择结婚备案→填写结婚相关信息→上传双方结婚证扫描件、配偶身份证及户口本扫描件→提交审核→系统审核→审核通过→业务办结。<br>审核不通过→注明不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='44' style='mso-height-source:userset;height:33pt' name='r6'>
                                            <td height='42' class='x23' style='height:31.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='48' style='mso-height-source:userset;height:36pt' name='r7'>
                                            <td height='46' class='x23' style='height:34.5pt;'>结果送达</td>
                                            <td class='x24'>无</td>
                                        </tr>
                                        <tr height='92' style='mso-height-source:userset;height:69pt' name='r8'>
                                            <td height='90' class='x23' style='height:67.5pt;'>收费标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='54' style='mso-height-source:userset;height:41pt' name='r10'>
                                            <td height='52' class='x23' style='height:39.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='108' style='mso-height-source:userset;height:81pt' name='r11'>
                                            <td height='106' class='x23' style='height:79.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                           <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='703' style='width:527.25pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='2-5'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='806' style='border-collapse:
 collapse;table-layout:fixed;width:604pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='666' style='mso-width-source:userset;width:499.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='806' style='height:23.25pt;'>
                                                离婚备案
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>离婚备案</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员在办理离婚登记后进行备案</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r3'>
                                            <td height='54' class='x25' style='height:40.5pt;'>办理材料</td>
                                            <td class='x24'>离婚证、离婚协议书</td>
                                        </tr>
                                        <tr height='92' style='mso-height-source:userset;height:69pt' name='r4'>
                                            <td rowspan='2' height='211' class='x29'
                                                style='border-right:1px solid windowtext;height:158.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4"><br>窗口办理<br></font><font class="font5">取号→提交申请材料→审核通过→工作人员登记信息→业务办结。<br>审核不通过→当场告知不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='120' style='mso-height-source:userset;height:90pt' name='r5'>
                                            <td class='x26 first'><font class="font4"><br>网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择离婚备案→上传离婚证、离婚协议书扫描件→提交审核→系统审核→审核通过→业务办结。<br>审核不通过→注明不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='44' style='mso-height-source:userset;height:33pt' name='r6'>
                                            <td height='42' class='x23' style='height:31.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r7'>
                                            <td height='38' class='x23' style='height:28.5pt;'>结果送达</td>
                                            <td class='x24'>无</td>
                                        </tr>
                                        <tr height='97' style='mso-height-source:userset;height:73pt' name='r8'>
                                            <td height='95' class='x23' style='height:71.5pt;'>收费标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30<span style='mso-spacerun:yes;'>&nbsp; </span><br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='53' style='mso-height-source:userset;height:40pt' name='r10'>
                                            <td height='51' class='x23' style='height:38.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='93' style='mso-height-source:userset;height:70pt' name='r11'>
                                            <td height='91' class='x23' style='height:68.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='54' style='mso-height-source:userset;height:41pt' name='r12'>
                                           <td height='52' class='x23' style='height:39.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='666' style='width:499.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='2-6'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='822' style='border-collapse:
 collapse;table-layout:fixed;width:616pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='682' style='mso-width-source:userset;width:511.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x28' width='822' style='height:23.25pt;'>
                                                生育备案
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>生育备案</td>
                                        </tr>
                                        <tr height='41' style='mso-height-source:userset;height:31pt' name='r2'>
                                            <td height='39' class='x23' style='height:29.5pt;'>事项简述</td>
                                            <td class='x24'>在户人员在生育前后进行备案</td>
                                        </tr>
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r3'>
                                            <td height='50' class='x25' style='height:37.5pt;'>办理材料</td>
                                            <td class='x24'>生育前：生育登记材料 <br>生育后：生育登记材料、出生医学证明、小孩户口（如小孩已上户请上传户口簿户主页及小孩个人页）
                                            </td>
                                        </tr>
                                        <tr height='100' style='mso-height-source:userset;height:75pt' name='r4'>
                                            <td rowspan='2' height='220' class='x29'
                                                style='border-right:1px solid windowtext;height:165.25pt;'>办理方式
                                            </td>
                                            <td class='x26'><font class="font4"><br>窗口办理<br></font><font class="font5">取号→提交申请材料→审核通过→工作人员登记信息→业务办结。<br>审核不通过→当场告知不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='121' style='mso-height-source:userset;height:91pt' name='r5'>
                                            <td class='x26 first'><font class="font4"><br>网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→申请生育备案→上传办理材料扫描件→提交审核→系统审核→审核通过→业务办结。<br>审核不通过→注明不通过原因。<br></font>
                                            </td>
                                        </tr>
                                        <tr height='44' style='mso-height-source:userset;height:33pt' name='r6'>
                                            <td height='42' class='x23' style='height:31.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='49' style='mso-height-source:userset;height:37pt' name='r7'>
                                            <td height='47' class='x23' style='height:35.5pt;'>结果送达</td>
                                            <td class='x24'>无</td>
                                        </tr>
                                        <tr height='92' style='mso-height-source:userset;height:69pt' name='r8'>
                                            <td height='90' class='x23' style='height:67.5pt;'>收费标准</td>
                                            <td class='x27'>免费</td>
                                        </tr>
                                        <!--<tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                          <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                          <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                        </tr>-->
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r10'>
                                            <td height='54' class='x23' style='height:40.5pt;'>办理地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='80' style='mso-height-source:userset;height:60pt' name='r11'>
                                            <td height='78' class='x23' style='height:58.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='56' style='mso-height-source:userset;height:42pt' name='r12'>
                                           <td height='54' class='x23' style='height:40.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='682' style='width:511.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-1'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='813' style='border-collapse:
 collapse;table-layout:fixed;width:609pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='673' style='mso-width-source:userset;width:504.75pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='813' style='height:23.25pt;'>
                                                高等学校等毕业生接收手续办理
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>高等学校等毕业生接收手续办理</td>
                                        </tr>
                                        <tr height='117' style='mso-height-source:userset;height:88pt' name='r2'>
                                            <td height='115' class='x23' style='height:86.5pt;'>事项简述</td>
                                            <td class='x24'>1.办理内容：接收应届高校毕业生档案<br>
                                                2.接收范围：<br>
                                                ①中央驻穗及省直事业单位非编制内聘用毕业生的人事档案；<br>
                                                ②在省市场监管部门注册的非公有制企业聘用毕业生的人事档案；<br>
                                                ③在省民政部门登记的社会组织聘用毕业生的人事档案。
                                            </td>
                                        </tr>
                                        <tr height='34' style='mso-height-source:userset;height:26pt' name='r3'>
                                            <td height='32' class='x25' style='height:24.5pt;'>办理材料</td>
                                            <td class='x24'>有效身份证件、毕业生就业协议书原件。<br>
                                                注： ①用人单位须在《毕业生就业协议书》中“用人单位”栏签署意见并加盖公章；<br>
                                                ②申报材料须清晰、准确、真实、完整，不得涂改。
                                            </td>
                                        </tr>
                                        <tr height='105' style='mso-height-source:userset;height:79pt' name='r4'>
                                            <td rowspan='2' height='252' class='x30'
                                                style='border-right:1px solid windowtext;height:189.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→工作人员开具接收函→申请人从学校办理档案转出手续→学校通过机要或者EMS标准快递将档案寄送我局（严禁个人自带档案）→工作人员审核档案→审核通过，档案登记入库（如档案缺少关键材料，申请人需下载填写告知承诺书并邮寄到我局）。审核不通过的，将档案退回学校。
                                                <br>材料审核不通过→当场告知不通过原因。</font></td>
                                        </tr>
                                        <tr height='148' style='mso-height-source:userset;height:111pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择毕业生接收→填写申办信息→上传《毕业生就业协议书》扫描件→提交审核→系统审核→审核通过→工作人员通过EMS快递寄出接收函或申请人在线打印接收函→申请人从学校办理档案转出手续→学校通过机要或者EMS标准快递将档案寄送我局（严禁个人自带档案）→工作人员审核档案→审核通过，档案登记入库（如档案缺少关键材料，申请人需下载填写告知承诺书并邮寄到我局）。审核不通过的，将档案退回学校。
                                                <br>材料审核不通过→当场告知不通过原因。</font></td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r6'>
                                            <td height='38' class='x23' style='height:28.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='50' style='mso-height-source:userset;height:38pt' name='r7'>
                                            <td height='48' class='x23' style='height:36.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，在线下载或邮寄送达。</td>
                                        </tr>
                                        <tr height='88' style='mso-height-source:userset;height:66pt' name='r8'>
                                            <td height='86' class='x23' style='height:64.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <!-- <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                           <td height='70' class='x23' style='height:52.5pt;'>办事时间</td>
                                           <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                         </tr>-->
                                        <tr height='53' style='mso-height-source:userset;height:40pt' name='r10'>
                                            <td height='51' class='x23' style='height:38.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r11'>
                                            <td height='87' class='x23' style='height:65.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!--  <tr height='52' style='mso-height-source:userset;height:39pt' name='r12'>
                                            <td height='50' class='x23' style='height:37.5pt;'>监督投诉渠道</td>
                                            <td class='x24
                                            '>人社系统投诉电话：12333</td>
                                          </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='673' style='width:504.75pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>

                                </div>

                                <div v-show="ywsm=='1-2'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='813' style='border-collapse:
 collapse;table-layout:fixed;width:609pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='673' style='mso-width-source:userset;width:504.75pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='813' style='height:23.25pt;'>
                                                档案接收
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>档案接收</td>
                                        </tr>
                                        <tr height='117' style='mso-height-source:userset;height:88pt' name='r2'>
                                            <td height='115' class='x23' style='height:86.5pt;'>事项简述</td>
                                            <td class='x24'>1.办理内容：档案接收<br>2.文件规定：<br>①根据《关于进一步加强流动人员人事档案管理服务工作的通知》(人社部发〔2014〕90号）规定：“跨地区流动人员的人事档案，可由其户籍所在地或现工作单位所在地的公共就业和人才服务机构管理”。<br>
                                                ②根据《人力资源社会保障部办公厅关于简化优化流动人员人事档案管理服务的通知》（人社厅发〔2016〕75号）规定：“档案管理服务机构在接收档案时，对缺少材料的实行告知承诺制。对缺少关键材料的，一次性告知所缺材料及其可能造成的影响，经本人作出书面知情说明、承诺补充材料后予以接收，或与原工作单位协商退回并补充材料。关键材料一般是指用于核定存档人的出生日期、参加工作时间、入党时间、学历学位、工作经历等重要信息的材料”。<br>
                                                3.接收范围：<br>
                                                ①中央驻穗及省直事业单位非编制内聘用工作人员的人事档案；<br>
                                                ②在省市场监管部门注册的非公有制企业聘用工作人员的人事档案；<br>
                                                ③在省民政部门登记的社会组织聘用工作人员的人事档案。<br></td>
                                        <tr height='34' style='mso-height-source:userset;height:26pt' name='r3'>
                                            <td height='32' class='x25' style='height:24.5pt;'>办理材料</td>
                                            <td class='x24'>有效身份证件、劳动合同</td>
                                        </tr>
                                        <tr height='105' style='mso-height-source:userset;height:79pt' name='r4'>
                                            <td rowspan='2' height='252' class='x30'
                                                style='border-right:1px solid windowtext;height:189.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→工作人员开具调档函→申请人从原档案保管单位申请档案转出→原档案保管单位将档案通过机要或专人转递至我局（严禁个人自带档案）→工作人员审核档案→审核通过，档案登记入库（如档案缺少关键材料，申请人需下载填写告知承诺书并邮寄到我局）。审核不通过的，将档案退回原档案保管单位
                                                <br>审核不通过→当场告知不通过原因。</font></td>
                                        </tr>
                                        <tr height='148' style='mso-height-source:userset;height:111pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择档案接收→上传劳动合同扫描件→填写申办信息→提交审核→系统审核→审核通过→生成调档函（申请人可在系统下载调档函或通过EMS快递接收调档函）→申请人从原档案保管单位申请档案转出→原档案保管单位通过机要或专人将档案转递我局（严禁个人自带档案）→工作人员审核档案→符合要求的，档案登记入库（如档案缺少关键材料，申请人需下载填写告知承诺书并邮寄我局）。审核不通过的，将档案退回原档案保管单位。<br>审核不通过→注明不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r6'>
                                            <td height='38' class='x23' style='height:28.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='50' style='mso-height-source:userset;height:38pt' name='r7'>
                                            <td height='48' class='x23' style='height:36.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，在线下载或邮寄送达。</td>
                                        </tr>
                                        <tr height='88' style='mso-height-source:userset;height:66pt' name='r8'>
                                            <td height='86' class='x23' style='height:64.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!-- <tr height='53' style='mso-height-source:userset;height:40pt' name='r10'>
                                           <td height='51' class='x23' style='height:38.5pt;'>办理机构及地点</td>
                                           <td class='x24'>广东省人才服务局<br>广州市越秀区天河路13号润粤大厦三楼服务大厅</td>
                                         </tr>-->
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r11'>
                                            <td height='87' class='x23' style='height:65.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='52' style='mso-height-source:userset;height:39pt' name='r12'>
                                           <td height='50' class='x23' style='height:37.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='673' style='width:504.75pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>

                                </div>

                                <div v-show="ywsm=='1-3'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='798' style='border-collapse:
 collapse;table-layout:fixed;width:598pt'>
                                        <col class='x22' width='118' style='mso-width-source:userset;width:88.5pt'>
                                        <col class='x21' width='680' style='mso-width-source:userset;width:510pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='798' style='height:23.25pt;'>
                                                档案转出
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>档案转出</td>
                                        </tr>
                                        <tr height='54' style='mso-height-source:userset;height:41pt' name='r2'>
                                            <td height='52' class='x23' style='height:39.5pt;'>事项简述</td>
                                            <td class='x24'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：将人事档案转递至有人事档案管理权限的接收单位</td>
                                        </tr>
                                        <tr height='141' style='mso-height-source:userset;height:106pt' name='r3'>
                                            <td height='139' class='x25' style='height:104.5pt;'>办理材料</td>
                                            <td class='x26'>1.个人办理：存档人员有效身份证件、调档函。<br>2.委托代办：存档人员亲笔签名的委托书（注明双方联系方式）、委托人有效身份证件复印件以及受委托人有效身份证件原件、调档函。<br>3.单位办理：单位介绍信（注明经办人身份信息）、经办人有效身份证件、调档函。<br>注：<br>注：①一次性转出多人档案的，需提供转出人员名单及电话号码，并加盖公章。（以短信方式告知转出人须在3个月内转出在我局的集体户口及党员组织关系。）<br>②由上级单位授权管理人事档案的单位应提供授权证明材料。(无档案保管权的需有档案保管权的上级单位开函接收)
                                            </td>
                                        </tr>
                                        <tr height='109' style='mso-height-source:userset;height:82pt' name='r4'>
                                            <td rowspan='2' height='257' class='x30'
                                                style='border-right:1px solid windowtext;height:193.25pt;'>办理方式
                                            </td>
                                            <td class='x27'><font class="font4">窗口办理<span style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→工作人员整理并密封档案→档案通过单位预约提取、邮政特快专递或机要寄递的方式转往档案接收单位（单位预约提取需提供单位介绍信及经办人有效身份证件）→档案接收单位收到档案，将档案转递通知单回执寄到我局<br>审核不通过→当场告知不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='149' style='mso-height-source:userset;height:112pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择档案转出→上传调档函扫描件→填写申办信息→提交审核→系统审核→审核通过→工作人员整理并密封档案→档案通过机要转递或单位预约提取→接收单位收到档案，将档案转递通知单回执寄到我局。<br>审核不通过→注明不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='45' style='mso-height-source:userset;height:34pt' name='r6'>
                                            <td height='43' class='x23' style='height:32.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r7'>
                                            <td height='38' class='x23' style='height:28.5pt;'>结果送达</td>
                                            <td class='x24'>机要送达</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='60' style='mso-height-source:userset;height:45pt' name='r10'>
                                            <td height='58' class='x23' style='height:43.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='88' style='mso-height-source:userset;height:66pt' name='r11'>
                                           <td height='86' class='x23' style='height:64.5pt;'>咨询查询途径</td>
                                           <td class='x24'>现场咨询：广东省人才服务局服务大厅<br>电话咨询：020-12333-9<br>网站查询：登录广东省流动人员人事档案公共服务平台（https://ggfw.hrss.gd.gov.cn/rsda）可查看办事指南、查询档案在库信息、在线申办业务</td>
                                         </tr>-->
                                        <!-- <tr height='56' style='mso-height-source:userset;height:42pt' name='r12'>
                                           <td height='54' class='x23' style='height:40.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='118' style='width:88.5pt'></td>
                                            <td width='680' style='width:510pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-4'" style="padding:15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='802' style='border-collapse:
 collapse;table-layout:fixed;width:601pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='662' style='mso-width-source:userset;width:496.5pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='802' style='height:23.25pt;'>
                                                档案材料的收集、鉴别和归档
                                            </td>
                                        </tr>
                                        <tr height='42' style='mso-height-source:userset;height:32pt' name='r1'>
                                            <td height='40' class='x23' style='height:30.5pt;'>事项名称</td>
                                            <td class='x24'>档案材料的收集、鉴别和归档</td>
                                        </tr>
                                        <tr height='152' style='mso-height-source:userset;height:114pt' name='r2'>
                                            <td height='150' class='x23' style='height:112.5pt;'>事项简述</td>
                                            <td class='x24'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：将符合归档规定的材料放入个人人事档案<br>注：<br>①档案材料应为办理完毕的正式材料，完整齐全、文字清楚、内容真实、填写规范、手续完备。<br>②证书、证件等特殊情况需用复印件存档的，应由材料制作单位注明复印时间并加盖公章。<br>③已密封材料请勿擅自拆封。
                                            </td>
                                        </tr>
                                        <tr height='114' style='mso-height-source:userset;height:86pt' name='r3'>
                                            <td height='112' class='x25' style='height:84.5pt;'>办理材料</td>
                                            <td class='x26'>1.个人办理：存档人员有效身份证件、归档材料原件。<br>2.委托代办：存档人员手写签名的委托书（注明双方联系方式）、委托人有效身份证件以及受委托人有效身份证件、归档材料原件。<br>3.单位办理：单位介绍信（注明经办人身份信息）、经办人有效身份证件、归档材料原件。（批量归档时需提供材料清单）
                                            </td>
                                        </tr>
                                        <tr height='90' style='mso-height-source:userset;height:68pt' name='r4'>
                                            <td rowspan='2' height='203' class='x30'
                                                style='border-right:1px solid windowtext;height:152.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→工作人员收集、鉴别档案材料→符合要求的，档案材料归入档案。不符合要求的，解释相关原因，并将档案材料退回申请人。
                                                <br>审核不通过→当场告知不通过原因。</font></td>
                                        </tr>
                                        <tr height='113' style='mso-height-source:userset;height:85pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择档案材料归档→上传档案材料扫描件→填写申办信息→提交审核→系统审核→审核通过→申请人填写寄件信息→寄出档案材料原件→工作人员收集、鉴别档案材料→符合要求的，档案材料归入档案。不符合要求的，解释相关原因，并将档案材料退回申请人。<br>审核不通过→注明不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='37' style='mso-height-source:userset;height:28pt' name='r6'>
                                            <td height='35' class='x23' style='height:26.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r7'>
                                            <td height='50' class='x23' style='height:37.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场归档；<br>网上办理的，收到邮寄材料后归档。</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!--<tr height='53' style='mso-height-source:userset;height:40pt' name='r10'>
                                          <td height='51' class='x23' style='height:38.5pt;'>办理机构及地点</td>
                                          <td class='x24'>广东省人才服务局<br>广州市越秀区天河路13号润粤大厦三楼服务大厅</td>
                                        </tr>-->
                                        <tr height='100' style='mso-height-source:userset;height:75pt' name='r11'>
                                            <td height='98' class='x23' style='height:73.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!--<tr height='52' style='mso-height-source:userset;height:39pt' name='r12'>
                                          <td height='50' class='x23' style='height:37.5pt;'>监督投诉渠道</td>
                                          <td class='x24'>人社系统投诉电话：12333</td>
                                        </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='662' style='width:496.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-5'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='778' style='border-collapse:
 collapse;table-layout:fixed;width:583pt'>
                                        <col class='x22' width='121' style='mso-width-source:userset;width:90.75pt'>
                                        <col class='x21' width='657' style='mso-width-source:userset;width:492.75pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='778' style='height:23.25pt;'>
                                                档案查阅
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>档案查阅</td>
                                        </tr>
                                        <tr height='260' style='mso-height-source:userset;height:195pt' name='r2'>
                                            <td height='258' class='x23' style='height:193.5pt;'>事项简述</td>
                                            <td class='x24'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：因工作需要，符合下列情形之一的，可以查阅人事档案<br>（一）政治审查、发展党员、党员教育、党员管理等；<br>（二）干部录用、聘用、考核、考察、任免、调配、职级晋升、教育培养、职称评聘、表彰奖励、工资待遇、公务员登记备案、退（离）休、社会保险、治丧等；<br>（三）人才引进、培养、评选、推送等；<br>（四）巡视、巡察，选人用人检查、违规选人用人问题查核，组织处理，党纪政务处分，涉嫌违法犯罪的调查取证、案件查办等；<br>（五）经具有干部管理权限的党委（党组）、组织人事部门批准的编史修志，撰写大事记、人物传记，举办展览、纪念活动等；<br>（六）日常管理中，熟悉了解干部，研究、发现和解决有关问题等；<br>（七）本人及其亲属办理公证、诉讼取证等有关个人合法权益保障的事项，可以按照有关规定提请相应的组织人事等部门查阅档案。<br>（八）因工作需要的其他情形。
                                            </td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r3'>
                                            <td height='70' class='x25' style='height:52.5pt;'>办理材料</td>
                                            <td class='x26'>查阅函（函上应注明查阅人和被查阅人的姓名及身份证号，查阅事由）、查阅人有效身份证件</td>
                                        </tr>
                                        <tr height='85' style='mso-height-source:userset;height:64pt' name='r4'>
                                            <td rowspan='2' height='184' class='x30'
                                                style='border-right:1px solid windowtext;height:138.25pt;'>办理方式
                                            </td>
                                            <td class='x28 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→查阅人在阅档区查阅档案。（注：查阅流动人员人事档案应当2人以上，一般为中共党员）<br>审核不通过→当场告知不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='100' style='mso-height-source:userset;height:75pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理</font><font
                                                    class="font5"><br>登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择档案查阅→上传查阅函扫描件→填写申办信息→提交审核→系统审核→审核通过→在已办业务栏目预约查阅时间→按照预约时间查阅档案。（注：查阅流动人员人事档案应当2人以上，一般为中共党员）
                                                <br>材料审核不通过→注明不通过原因。</font></td>
                                        </tr>
                                        <tr height='45' style='mso-height-source:userset;height:34pt' name='r6'>
                                            <td height='43' class='x23' style='height:32.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='60' style='mso-height-source:userset;height:45pt' name='r7'>
                                            <td height='58' class='x23' style='height:43.5pt;'>结果送达</td>
                                            <td class='x24'>符合规定的，查档单位现场阅档；<br>不符合规定的，解释相关规定。</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!-- <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                           <td height='50' class='x23' style='height:37.5pt;'>办理机构及地点</td>
                                           <td class='x24'>广东省人才服务局<br>广州市越秀区天河路13号润粤大厦三楼服务大厅</td>
                                         </tr>-->
                                        <tr height='90' style='mso-height-source:userset;height:68pt' name='r11'>
                                            <td height='88' class='x23' style='height:66.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='61' style='mso-height-source:userset;height:46pt' name='r12'>
                                           <td height='59' class='x23' style='height:44.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='121' style='width:90.75pt'></td>
                                            <td width='657' style='width:492.75pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-6'" style="padding:15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='808' style='border-collapse:
 collapse;table-layout:fixed;width:606pt'>
                                        <col class='x22' width='140' style='mso-width-source:userset;width:105pt'>
                                        <col class='x21' width='668' style='mso-width-source:userset;width:501pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='808' style='height:23.25pt;'>
                                                档案借阅
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>档案借阅</td>
                                        </tr>
                                        <tr height='102' style='mso-height-source:userset;height:77pt' name='r2'>
                                            <td height='100' class='x23' style='height:75.5pt;'>事项简述</td>
                                            <td class='x24'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：有人事档案管理权限的单位依据规定借阅人事档案<br>注：档案一般不外借。如必须外借的，应由借阅单位以书面形式说明理由，经我局审核通过后办理登记手续，并在1个月内归还档案。
                                            </td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r3'>
                                            <td height='70' class='x25' style='height:52.5pt;'>办理材料</td>
                                            <td class='x26'>借阅函（函上应注明借阅人和被借阅人的姓名及身份证号，借阅事由）、借阅人有效身份证件</td>
                                        </tr>
                                        <tr height='125' style='mso-height-source:userset;height:94pt' name='r4'>
                                            <td rowspan='2' height='227' class='x30'
                                                style='border-right:1px solid windowtext;height:170.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→借阅人在《流动人员人事档案借阅登记表》上登记（批量借阅档案时，须提供加盖公章的档案人员名单）→工作人员审核、整理档案，并告知借阅人归还日期→档案借出→借阅单位在1个月内通过邮政特快专递、机要寄递的方式或安排专人归还档案→工作人员核对档案借阅登记材料，登记入库。<br>审核不通过→当场告知不通过原因。<span
                                                    style='mso-spacerun:yes;white-space:nowrap;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></font>
                                            </td>
                                        </tr>
                                        <tr height='102' style='mso-height-source:userset;height:77pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择档案借阅→上传借阅函扫描件→填写申办信息→提交审核→系统审核→审核通过→工作人员审核、整理档案，将档案通过机要转递到借阅单位→借阅单位在1个月内将档案通过机要或单位专人归还我局→工作人员核对档案借阅登记材料，登记入库。<br>审核不通过→注明不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='42' style='mso-height-source:userset;height:32pt' name='r6'>
                                            <td height='40' class='x23' style='height:30.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='57' style='mso-height-source:userset;height:43pt' name='r7'>
                                            <td height='55' class='x23' style='height:41.5pt;'>结果送达</td>
                                            <td class='x24'>符合规定的，工作人员将档案密封盖章，通过机要转递或交给借阅单位；<br>不符合规定的，解释相关规定。</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼） <br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!-- <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                           <td height='50' class='x23' style='height:37.5pt;'>办理机构及地点</td>
                                           <td class='x24'>广东省人才服务局<br>广州市越秀区天河路13号润粤大厦三楼服务大厅</td>
                                         </tr>-->
                                        <tr height='94' style='mso-height-source:userset;height:71pt' name='r11'>
                                            <td height='92' class='x23' style='height:69.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='56' style='mso-height-source:userset;height:42pt' name='r12'>
                                           <td height='54' class='x23' style='height:40.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='140' style='width:105pt'></td>
                                            <td width='668' style='width:501pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-7'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='787' style='border-collapse:
 collapse;table-layout:fixed;width:590pt'>
                                        <col class='x22' width='133' style='mso-width-source:userset;width:99.75pt'>
                                        <col class='x21' width='654' style='mso-width-source:userset;width:490.5pt'>
                                        <tr height='37' style='mso-height-source:userset;height:28pt' name='r0'>
                                            <td colspan='2' height='36' class='x29' width='787' style='height:27.25pt;'>
                                                依据档案记载出具相关证明
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>依据档案记载出具相关证明</td>
                                        </tr>
                                        <tr height='69' style='mso-height-source:userset;height:52pt' name='r2'>
                                            <td height='67' class='x23' style='height:50.5pt;'>事项简述</td>
                                            <td class='x26'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：存档证明、经历证明、亲属关系证明、无犯罪记录证明等</td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r3'>
                                            <td height='96' class='x25' style='height:72.5pt;'>办理材料</td>
                                            <td class='x26'>1.个人办理：存档人员有效身份证件。<br>2.委托代办：存档人员手写签名的委托书（注明双方联系方式）、委托人有效身份证件以及受委托人有效身份证件。<br>3.单位办理：单位介绍信（注明经办人员身份信息）、经办人有效身份证件。
                                            </td>
                                        </tr>
                                        <tr height='97' style='mso-height-source:userset;height:73pt' name='r4'>
                                            <td rowspan='2' height='215' class='x30'
                                                style='border-right:1px solid windowtext;height:161.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交申请材料→审核通过→开具证明，当场给申请人。<br>审核不通过→当场告知不通过原因。<span
                                                    style='mso-spacerun:yes;white-space:nowrap;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></font>
                                            </td>
                                        </tr>
                                        <tr height='118' style='mso-height-source:userset;height:89pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理</font><font
                                                    class="font5"><br>登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择申请出具证明→填写申办信息提交审核→系统审核→审核通过→生成证明（选择邮寄方式的，工作人员将证明通过EMS快递寄出；选择在线下载的，请在已办业务中下载证明。）
                                                <br>审核不通过→注明不通过原因。</font></td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='56' style='mso-height-source:userset;height:42pt' name='r7'>
                                            <td height='54' class='x23' style='height:40.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，邮寄送达或在线下载。</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x26'>免费</td>
                                        </tr>
                                        <!--<tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                          <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                          <td class='x24'>周一至周四：上午 8：30—12：00，下午 14：00-17：30 <br>周五：上午8:30-12:00<br>周五下午、法定节假日不对外办公</td>
                                        </tr>-->
                                        <tr height='52' style='mso-height-source:userset;height:39pt' name='r10'>
                                            <td height='50' class='x23' style='height:37.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <tr height='98' style='mso-height-source:userset;height:74pt' name='r11'>
                                            <td height='96' class='x23' style='height:72.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!--<tr height='56' style='mso-height-source:userset;height:42pt' name='r12'>
                                          <td height='54' class='x23' style='height:40.5pt;'>监督投诉渠道</td>
                                          <td class='x24'>人社系统投诉电话：12333</td>
                                        </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='133' style='width:99.75pt'></td>
                                            <td width='654' style='width:490.5pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>
                                </div>

                                <div v-show="ywsm=='1-8'" style="padding: 15px 50px;">
                                    <table border='0' cellpadding='0' cellspacing='0' width='837' style='border-collapse:
 collapse;table-layout:fixed;width:627pt'>
                                        <col class='x22' width='134' style='mso-width-source:userset;width:100.5pt'>
                                        <col class='x21' width='703' style='mso-width-source:userset;width:527.25pt'>
                                        <tr height='32' style='mso-height-source:userset;height:24pt' name='r0'>
                                            <td colspan='2' height='31' class='x29' width='837' style='height:23.25pt;'>
                                                为相关单位提供政审（考察）服务
                                            </td>
                                        </tr>
                                        <tr height='40' style='mso-height-source:userset;height:30pt' name='r1'>
                                            <td height='38' class='x23' style='height:28.5pt;'>事项名称</td>
                                            <td class='x24'>为相关单位提供政审（考察）服务</td>
                                        </tr>
                                        <tr height='66' style='mso-height-source:userset;height:50pt' name='r2'>
                                            <td height='64' class='x23' style='height:48.5pt;'>事项简述</td>
                                            <td class='x24'>办理条件：人事档案已在广东省人才服务局保管<br>办理内容：参军、录用、入党、出国（境）、升学政审以及其他政审</td>
                                        </tr>
                                        <tr height='61' style='mso-height-source:userset;height:46pt' name='r3'>
                                            <td height='59' class='x25' style='height:44.5pt;'>办理材料</td>
                                            <td class='x26'>政审函（函上应注明经办人和被政审人的姓名及身份证号，政审事由）、政审表格、有效身份证件</td>
                                        </tr>
                                        <tr height='80' style='mso-height-source:userset;height:60pt' name='r4'>
                                            <td rowspan='2' height='191' class='x30'
                                                style='border-right:1px solid windowtext;height:143.25pt;'>办理方式
                                            </td>
                                            <td class='x27 first'><font class="font4">窗口办理<span
                                                    style='mso-spacerun:yes;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><br></font><font
                                                    class="font5">取号→提交办理材料→审核通过→工作人员审查档案出具政审材料。<br>审核不通过→当场告知不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='112' style='mso-height-source:userset;height:84pt' name='r5'>
                                            <td class='x27 first'><font class="font4">网上办理<br></font><font
                                                    class="font5">登录广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）→选择为相关单位提供政审（考察）服务→上传政审函、政审表格扫描件→填写申办信息→提交审核→系统审核→审核通过→工作人员审查档案→出具政审材料→工作人员通过EMS快递寄出政审材料。<br>审核不通过→注明不通过原因。</font>
                                            </td>
                                        </tr>
                                        <tr height='46' style='mso-height-source:userset;height:35pt' name='r6'>
                                            <td height='44' class='x23' style='height:33.5pt;'>办理时限</td>
                                            <td class='x24'>即时办结</td>
                                        </tr>
                                        <tr height='57' style='mso-height-source:userset;height:43pt' name='r7'>
                                            <td height='55' class='x23' style='height:41.5pt;'>结果送达</td>
                                            <td class='x24'>窗口办理的，当场送达；<br>网上办理的，邮寄送达。</td>
                                        </tr>
                                        <tr height='89' style='mso-height-source:userset;height:67pt' name='r8'>
                                            <td height='87' class='x23' style='height:65.5pt;'>收费标准</td>
                                            <td class='x24'>免费</td>
                                        </tr>
                                        <tr height='72' style='mso-height-source:userset;height:54pt' name='r9'>
                                            <td height='70' class='x23' style='height:52.5pt;'>办事地点时间</td>
                                            <td class='x24'>粤港澳大湾区（广东）人才港公共服务大厅（广州市越秀区东风中路389号壬丰商务大厦5楼）<br>周一至周五：上午
                                                8：30—12：00，下午 14：00-17：30<br>法定节假日不对外办公
                                            </td>
                                        </tr>
                                        <!-- <tr height='57' style='mso-height-source:userset;height:43pt' name='r10'>
                                           <td height='55' class='x23' style='height:41.5pt;'>办理机构及地点</td>
                                           <td class='x24'>广东省人才服务局<br>广州市越秀区天河路13号润粤大厦三楼服务大厅</td>
                                         </tr>-->
                                        <tr height='94' style='mso-height-source:userset;height:71pt' name='r11'>
                                            <td height='92' class='x23' style='height:69.5pt;'>咨询监督途径</td>
                                            <td class='x24'>咨询电话：020-12345<br>查询网站：广东省流动人员人事档案公共服务平台
                                                （https://ggfw.hrss.gd.gov.cn/rsda）<br>投诉电话：020-12333-9
                                            </td>
                                        </tr>
                                        <!-- <tr height='57' style='mso-height-source:userset;height:43pt' name='r12'>
                                           <td height='55' class='x23' style='height:41.5pt;'>监督投诉渠道</td>
                                           <td class='x24'>人社系统投诉电话：12333</td>
                                         </tr>-->
                                        <![if supportMisalignedColumns]>
                                        <tr height='0' style='display:none'>
                                            <td width='134' style='width:100.5pt'></td>
                                            <td width='703' style='width:527.25pt'></td>
                                        </tr>
                                        <![endif]>
                                    </table>

                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div  class="footer">
            <div style="width: 1000px;margin: 0px auto;padding: 15px 0; position: relative;">
                <div style="position: absolute;left: 0;">
                           <span id="_ideConac" style="vertical-align: middle;">
                               <a href="https://bszs.conac.cn/sitename?method=show&amp;id=09D723E079105148E053012819AC0D35" target="_blank">
                                   <img id="imgConac" width="100px" vspace="0" hspace="0" border="0" src="../../static/img/red.png" data-bd-imgshare-binded="1">
                               </a>
                           </span>

                    <span id="_span_jiucuo" style="vertical-align: middle;">
                                <img onclick="Link('4400000106')" style="margin:0;border:0;cursor: pointer;" src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=4400000106"/>
                            </span>
                </div>
                <div style="text-align: center;line-height: 35px;font-size: 15px;color:#FFF">
                    <p>主办单位：广东省人力资源和社会保障厅</p>
                    <p>地址：广州市东风中路483号、广州市教育路88号 电话:020-12333</p>
                    <p>版权所有：广东省人力资源和社会保障厅 未经授权禁止复制或建立镜像</p>
                    <div style="display:inline-block">
                        <p>
                            <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#FFF">粤ICP备12027628号</a>&nbsp;&nbsp;&nbsp;
                            <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402000400"
                               target="_blank" style="color:#FFF">
                                <img src="../../static/img/batb.png" style="vertical-align: middle;">粤公网安备44010402000400号
                            </a>
                            &nbsp;&nbsp;&nbsp;网站标识码：4400000106
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!--<script id="_jiucuo_" sitecode="4400000106" src="https://zfwzgl.www.gov.cn/exposure/jiucuo.js"></script>-->
<script >
    export default {
        name: "home",
        data() {
            return {
                activeName: 'first',
                ywsm: '1-1',
                pageType: 1,
                navType: 0,
                options: [],
                value: [],
                list: [],
                loading: false,
                states: ['档案接收', '档案转出', '档案存储地查询', '出具证明', '档案借阅', '毕业生报到', '集体户业务', '党员相关业务'],
                screnWidth: document.body.clientWidth,  // 屏幕高
                type: 1,
                resultData: {
                    basePath: '',//请求地址
                    loginUrl: '',//登录路径
                    registUrl: '',//注册路径
                    logOutUrl: '',//退出登录路径
                    username: '',//用户名
                    comment: {
                        val1: 0,//办件数
                        val2: 0,//差评数
                        val3: 100,//整改率
                        val4: 5,//好评 最大值5
                    }
                },

            }
        },
        mounted() {
            console.log(window)
            console.log(window['mytest'])
            // this.$nextTick(() => {
            //   this.resultData = window.mytest;
            // })
            const s = document.createElement("script");
            s.type="text/javascript";
            s.src="https://zfwzgl.www.gov.cn/exposure/jiucuo.js";
            document.body.appendChild(s);
            let that = this;
            let time = 0;
            let timer = setInterval(function () {
                time++;
                if (window.mytest && JSON.stringify(window.mytest) != "{}") {
                    that.resultData = window.mytest;
                    console.log(that.resultData)
                    clearInterval(timer)
                } else {
                    if (time > 5) {
                        clearInterval(timer)
                    }
                }
            }, 1000)


            this.list = this.states.map(item => {
                return {value: `${item}`, label: `${item}`};
            });
        },
        methods: {

            handleOpen(key, keyPath) {
                console.log(key, keyPath);

            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            setZNVal(key) {

                this.$set(this, 'ywsm', key)

            },
            toZwpage(val) {
                let data = {}

                if (val == 1) {
                    data = {
                        path: 1,
                        name: '《关于简化优化流动人员人事档案管理服务的通知》（人社厅发﹝2016﹞75号）'
                    }
                } else if (val == 2) {
                    data = {
                        path: 2,
                        name: '《关于进一步加强流动人员人事档案管理服务工作的通知》 （人社部发﹝2014﹞90号）'
                    }
                } else if (val == 3) {
                    data = {
                        path: 3,
                        name: '《关于进一步明确我市公共就业人才服务机构集体户口挂靠人员办理婚姻登记和计划生育服务证有关问题的通知》（穗计生发〔2014〕27号）'
                    }
                } else if (val == 4) {
                    data = {
                        path: 4,
                        name: '《干部人事档案工作条例》'
                    }
                } else if (val == 5) {
                    data = {
                        path: 5,
                        name: '《广州市人民政府关于印发广州市户籍迁入管理规定的通知》（穗府规〔2018〕20号）'
                    }
                } else if (val == 6) {
                    data = {
                        path: 6,
                        name: '《广州市公安局关于印发广州市集体户口管理规定的通知》(穗公规字〔2020〕2号)'
                    }
                } else if (val == 7) {
                    data = {
                        path: 7,
                        name: '《流动人员人事档案管理暂行规定》（人发﹝1996﹞118号）'
                    }
                } else if (val == 8) {
                    data = {
                        path: 8,
                        name: '流动人员人事档案管理服务规范》（GBT 32623-2016）'
                    }
                }
                this.$router.push({
                    name: 'zwpage',
                    params: {
                        ...data
                    }
                })
            },
            handleClick() {
            },
            toRegist() {
                window.open(this.resultData.registUrl);
            },
            toPage1() {
                // window.open(this.resultData.basePath + this.resultData.matter)
                window.open(this.resultData.basePath + '/ldryh/center.do')
            },
            toLogin(val) {
                if (val) {
                    window.open(this.resultData.basePath + this.resultData.matter + '?page=' + val);
                } else {
                    window.location.href = this.resultData.loginUrl
                }

            },
            toLogout() {
                this.resultData.username = '';
                window.mytest = {};
                this.$axios.get(this.resultData.basePath + '/rsda/logout.do').then(res => {
                    console.log(res)
                    window.location.href = this.resultData.logOutUrl
                }).catch(err => {
                    console.log(err)
                })

            },
            typeChage(index) {
                this.type = index;
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            toSearh() {
                console.log(this.value)
                switch (this.value) {
                    case '档案接收':
                        this.toLogin('archivesInto')
                        break;
                    case '档案转出':
                        this.toLogin('archivesTurnOut')
                        break;
                    case '档案查阅':
                        this.toLogin('archivesBorrowing')
                        break;
                    case '出具证明':
                        this.toLogin('certify')
                        break;
                    case '毕业生报到':
                        // this.toLogin('toBysbd')
                        window.open(this.resultData.basePath + '/ldryh/center.do')
                        break;
                    case '户口业务':
                        this.toLogin('accountBusiness')
                        break;
                    case '党员相关业务':
                        this.toLogin('relationTransfer')
                        break;
                    default:
                        this.toLogin('')
                }


            },

            toRsdabzh() {
                window.open('https://ggfw.hrss.gd.gov.cn/rsdabzh');
            },


            toScroll(index) {
                this.pageType = 1;
                this.navType = index
                console.log(index)
                if (index == 2) {
                    this.type = 2;
                }
                if (index == 1) {
                    this.type = 1;
                }


                // if (index == 0) {
                //   this.$nextTick(() => {
                //     document.getElementById('id').scrollIntoView()
                //
                //   })
                // } else {
                //   document.getElementById('div').scrollIntoView()
                //  }
            }
        }
    }
</script>

<style scoped>

    .footer {
        /*position: fixed;*/
        /*left: 0;*/
        /*bottom: 0;*/
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        line-height: 25px;
        background: url("../../static/img/footer.jpg");
    /*            background-image: url(../../static/img/banner2.png);
*/
    }
    a:hover{
        color: white;
        text-decoration: underline;
    }

    .top {
        height: 100vh;
        background: url("../../static/img1/bg.jpg") center top no-repeat;
        background-size: cover;
        color: #fff;
        /*overflow: hidden;*/
        position: relative;
    }

    .header {
        width: 75rem;
        height: 6.125rem;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .header img {
        width: 3.75rem;
        height: 3.75rem;
        margin-top: 1.125rem;
        float: left;
        margin-right: 0.75rem;
    }

    .header h1 {
        font-family: '宋体';
        font-size: 1.8rem;
        color: #FFFFFF;
        line-height: 6.125rem;
        float: left;
        font-weight: normal;
    }

    .header div {
        float: right;
        line-height: 6.125rem;

    }

    /*.header div span {*/
    /*font-size: 1.125rem;*/
    /*color: #FFFFFF;*/
    /*text-align: left;*/
    /*}*/

    .header div select {
        margin: 0 0.6875rem 0 1.0625rem;
    }

    .header div button {
        border: none;
        background: #3E93F7;
        width: 5.625rem;
        height: 2.3125rem;
        line-height: 2.3125rem;
        padding: 0 1rem;
        color: #fff;
        font-size: 0.8125rem;
    }

    nav {
        height: 3.25rem;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.11);
    }

    nav ul {
        width: 75rem;
        margin: 0 auto;
        position: relative;
    }

    nav ul li {
        display: inline-block;
        margin-right: 2.5rem;
        position: relative;
        height: 3.25rem;
        line-height: 3.25rem;
        font-size: 1rem;
        min-font-size: 16px;
        color: #FFFFFF;
        text-align: left;
        cursor: pointer;
    }

    nav ul li.active:before, nav ul li:hover::before {
        content: '';
        width: 100%;
        height: 0.25rem;
        background-color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;

    }

    .content {
        width: 75rem;
        position: absolute;
        top: 12rem;
        left: calc(50% - 37.5rem);
        display: flex;
        /*align-items: center;*/
        justify-content: center;
    }

    .content div {
        width: 30%;
    }

    .content > .div3 {
        flex: 1;
    }

    .div1 div, .div2 div {
        width: 90%;
        border-radius: 18px;
        background-color: #EDF9FF;
    }

    .div2 div {
        background-color: #EFF6FF;
    }

    .div1 div p, .div2 div p {
        border-radius: 18px 18px 0 0;
        background-color: #1BA5EB;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
    }

    .div2 div p {
        background-color: #5A9CF5;
    }

    .div1 div p img, .div2 div p img {
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: text-bottom;
    }

    .div1 div p span, .div2 div p span {
        margin-left: 4px;
    }

    .div1 div ul, .div2 div ul {
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        flex-wrap: wrap;
        padding-bottom: 20px;
    }

    .div1 div ul li, .div2 div ul li {
        width: 33.33%;
        list-style: none;
        text-align: center;
        margin: 20px 0 0;
        cursor: pointer;
    }

    .div1 div ul li img, .div2 div ul li img {
        width: 50px;
        height: 50px;
        display: block;
        margin: 0 auto 10px;
    }

    .div1 div ul li span, .div2 div ul li span {
        color: #1692D0;
        font-size: 16px;
        font-weight: 600;
    }

    .div2 div ul li span {
        color: #5A9CF5;
    }

    .content > .div3 div {
        background: #FFFFFF;
        border-radius: 0.625rem;
        padding: 0.625rem;
        box-sizing: border-box;
        width: 86%;
        float: right;
        position: relative
    }

    .content > .div3 div span.before {
        display: inline-block;
        position: absolute;
        font-size: 1rem;
        left: 0;
        top: 0;
        text-align: center;
        width: 100%;
        /*height: 100%;*/
    }

    .content > .div3 div p {
        padding: 1rem;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        text-indent: 2em;
        margin: 10px 0;
    }

    /*.content > .div3  div p span{*/
    /*color: #1BA5EB;*/
    /*}*/
    .content .div3 .bottom {
        width: 70%;
        float: right;
        margin-top: 40px;
        cursor: pointer;
    }

    .content .div3 .bottom img {
        width: 100px;
        height: 100px;
        display: inline-block;
        vertical-align: middle;
    }

    .content .div3 .bottom span {
        display: inline-block;
        background-image: linear-gradient(90deg, rgba(109, 208, 255, 0.50) 0%, rgba(142, 105, 249, 0.30) 98%);
        border: 1px solid #3EA6FE;
        border-radius: 20px;
        width: 200px;
        height: 50px;
        line-height: 50px;
        font-size: 26px;
        text-align: center;
    }

    /deep/ .el-input__inner {
        height: 2.25rem;
        line-height: 2.25rem;
    }

    .lists {
        width: 75rem;
        margin: 0 auto;
        /*min-height: 200vh;*/
    }

    .lists ul {
        /*padding: 3.1rem 0;*/
    }

    .lists li {
        /*width: 16rem;*/
        /*margin-right: 3rem;*/
        width: 23%;
        margin-right: 2%;
        margin-top: 3.1rem;
        /*height: 16.75rem;*/
        height: 11.75rem;
        display: inline-block;
        border: 1px solid #ccc;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
    }

    .lists li img {
        /*width: 53.5%;*/
        height: 32.73%;
        width: auto;
        margin: 2.417rem auto 0.85rem;
    }

    .lists li:hover {
        border-color: #264B8F;
        background-color: #264B8F;
    }

    .lists ul li > p.title {
        font-size: 1.33rem;
        font-weight: 500;
        color: #333;
        letter-spacing: 0;
    }

    .lists ul li:hover > p.title {
        /*color: #264B8F;*/
        color: #fff;
    }

    .lists ul li > p:last-child {
        position: absolute;
        left: 0;
        bottom: 0;
        font-size: 12px;
        color: #666;
        background-color: #E8F1FE;
        letter-spacing: 0;
        height: 48px;
        margin-top: 1rem;
        line-height: 1.8;
        text-align: left;
        padding: 0.4rem 1.6rem;
        box-sizing: border-box;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
        display: none;
    }

    .lists ul li:hover > p:last-child {
        background-color: #264B8F;
        color: #fff;
    }

    .lists li:nth-child(4n) {
        margin-right: 0;

    }

    /deep/ .el-rate__icon {
        margin-right: 0;
    }

    .portal-rating {
        margin: 3.75rem 0rem;
        padding: 3.8rem 0rem;
        width: 100%;
        background-image: url(../../static/img/banner2.png);
        background-size: 100% 100%;
        background-position: center;
    }

    .container {
        width: 75rem;
        padding: 0 1.9rem;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .portal-rating .portal-rating-title {
        color: #fff;
        margin-bottom: 1.2rem;
        *zoom: 1;
        position: relative;
    }

    .portal-rating .portal-rating-title > span {
        display: inline-block;
    }

    .portal-rating .portal-rating-title > span > p:first-child {
        font-size: 1.2rem;
        margin-right: .7rem;
        display: inline-block;
        line-height: 1.2rem;
        font-weight: 700;
    }

    .portal-rating .portal-rating-title > span > p:last-child {
        opacity: .7;
        line-height: 1.2rem;
        display: inline-block;
        font-size: .8rem;
    }

    .portal-rating .portal-rating-list {
        background: rgba(255, 255, 255, .1);
        padding: 2rem 0rem 2.1rem 0rem;
    }

    .portal-rating .portal-rating-list .portal-rating-item {
        display: inline-block;
        padding: 0rem 1.65rem;
        color: #fff;
        border-right: 1px solid rgba(255, 255, 255, .2);
        width: 24%;
        box-sizing: border-box;
    }

    .portal-rating .portal-rating-list .portal-rating-item:last-child {
        border-right: none;
    }

    .portal-rating .portal-rating-list .portal-rating-item .portal-rating-item-tip {
        color: rgba(255, 255, 255, .8);
        font-size: .8rem;
        line-height: 1.3rem;
        margin-bottom: .8rem;
    }

    .portal-rating .portal-rating-list .portal-rating-item .portal-rating-item-data {
        font-size: .9rem;
        line-height: 1.25rem;
        margin-top: 1rem;
    }

    .portal-rating .portal-rating-list .portal-rating-item .portal-rating-item-data > span {
        font-size: 2.4rem;
        line-height: 2.85rem;
        margin-right: .3rem;
    }

    .zwList li {
        line-height: 2;
        cursor: pointer;
    }

    /deep/ .el-button [class*=el-icon-] + span, /deep/ .el-icon-search:before, /deep/ .el-input--suffix .el-input__inner::-webkit-input-placeholder {
        font-size: 1rem;
    }

    /deep/ .el-input--suffix .el-input__inner::-webkit-input-placeholder {
        font-size: 1rem;
        padding-left: 1.2rem;
    }

    .f16 {
        font-size: 16px !important;
        font-weight: 700;
    }

    .table table {
        border-collapse: collapse;
    }

    .table td {
        border: 1px solid #999;
        font-size: 14px;
        padding: 1em;
        box-sizing: border-box;
        line-height: 1.8;
    }

    .table tr td:first-child, .font4 {
        font-weight: 600;
        text-align: center;
    }

    .table tr td.first {
        font-weight: normal;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/views/home.vue